import { CompanyForm, Country } from '../company/Company'

export enum FinancialStatementReportType {
  INCOME_STATEMENT = 'INCOME_STATEMENT',
  ASSETS = 'ASSETS',
  LIABILITIES = 'LIABILITIES'
}
export interface StatementRow {
  id: number
  code: string
  parentId: number
  title: string
  isParent: boolean
  report: FinancialStatementReportType
  investable?: boolean
  amendable?: boolean
  counterAmendable?: boolean
  depreciable?: boolean
  country: Country
  companyForm: CompanyForm
  rules?: []
  amendmentCounterPartRowIds?: number[]
}
